<template>
  <div class="thank">
    <div class="thank-img">
      <img src="https://imgcdn.chuxingyouhui.com/blackunique/upload/5f4608089254d0a6ae4e34c083261865.png">
    </div>
  </div>
</template>
<script>
export default {
  name: 'Thank',
  props: {
    number: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scale.scss';
.thank {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 630px * $scale;
  text-align: center;
  .thank-img {
    padding: 56px * $scale 141px * $scale 44px * $scale 163px * $scale;
    img {
      width: 316px * $scale;
      height: 221px * $scale;
      object-fit: contain;
    }
  }
  .title {
    font-size: 28px * $scale;
    font-weight: 500;
    color: #333;
    line-height: 44px * $scale;
    span {
      color: #FF0900;
    }
    &.top {
      margin-top: 41px * $scale;
    }
  }
}
</style>
